<template>
  <div class="department-form">
    <b-card>
      <template #header>
        <h2 class="mb-0">{{ isEdit ? $t('departments.edit_title') : $t('departments.create_title') }}</h2>
      </template>
      <b-form @submit.prevent="handleSubmit" :validated="validated" novalidate>
        <b-form-group
          :label="$t('departments.form.name_label')"
          label-for="name"
          :state="formErrors.has('name') ? false : null"
          :invalid-feedback="formErrors.first('name')"
        >
          <b-form-input
            id="name"
            v-model="formFields.name"
            :state="formErrors.has('name') ? false : null"
            required
            @input="removeError('name')"
          ></b-form-input>
        </b-form-group>
        
        <b-form-group
          :label="$t('departments.form.description_label')"
          label-for="description"
          :state="formErrors.has('description') ? false : null"
          :invalid-feedback="formErrors.first('description')"
        >
          <b-form-textarea
            id="description"
            v-model="formFields.description"
            :state="formErrors.has('description') ? false : null"
            rows="3"
            @input="removeError('description')"
          ></b-form-textarea>
        </b-form-group>
        
        <div class="d-flex gap-2 mt-4">
          <b-button type="submit" variant="primary" :disabled="loader">
            <b-spinner small v-if="loader" class="mr-1"></b-spinner>
            {{ loader ? $t('common.saving') : $t('common.save') }}
          </b-button>
          <b-button variant="secondary" @click="cancel">{{ $t('common.cancel') }}</b-button>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { request } from "@/Util/Request";
import NotifyMixin from "@/Util/NotifyMixin";
import Error from "@/Util/Error";
import { mapGetters } from "vuex";
export default {
  name: "DepartmentForm",
  mixins: [NotifyMixin],
  props: {
    id: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      validated: false,
      formErrors: new Error({}),
      formLevelError: "",
      formFields: {
        name: "",
        description: "",
      },
    };
  },
  computed: {
    isEdit() {
      return !!this.id;
    },
    ...mapGetters(['loader'])
  },
  methods: {
    async removeError(target) {
        if (typeof target === 'object') {
            for (let i = 0; i < target.length; i++) {
                this.formErrors.remove(target[i]);
            }
        } else {
            this.formErrors.remove(target);
        }
    },
    async fetchDepartment() {
      try {
        const response = await request({
          method: "get",
          url: `/departments/${this.id}`,
        });
        this.formFields = {
          ...this.formFields,
          ...response,
        };
      } catch (error) {
        this.formLevelError = error.data?.message || this.$t("departments.fetch_error");
        this.notifyErrorWithMsg(this.formLevelError);
        this.$router.push({name:"AdminDepartments"});
      }
    },
    async handleSubmit() {
      try {
        this.validated = true;
        this.formLevelError = "";
        const url = this.isEdit ? `/departments/${this.id}` : "/departments";
        const method = this.isEdit ? "put" : "post";
        await request({
          method,
          url,
          data: this.formFields,
        });

        const successMessage = this.isEdit 
          ? this.$t("departments.updated_successfully") 
          : this.$t("departments.created_successfully");
        this.notifySuccessWithMsg(successMessage);
        setTimeout(() => {
            this.$router.push({ name: "AdminDepartments" });
        }, 1000);
      } catch (err) {
        if(err?.data?.errors && err.status == 422){
          Object.assign(this.formErrors, new Error(err.data.errors));
          this.validated = true;
        }else{
          this.error = err.data?.message || this.$t("departments.save_error");
          this.notifyError(this.error);
        }
      }
    },
    cancel() {
      this.$router.push({name:"AdminDepartments"});
    },
  },
  async mounted() {
    if (this.isEdit) {
      await this.fetchDepartment();
    }
  },
};
</script>
